import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  materiel: [],
  materiale: [],
  suggestions: []
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        materiel: {
          $set: action.materiel
        },
        materiale: {
          $set: action.materiale
        }
    });
    case actionConsts.UPDATE_USAGE_AMOUNT:
      return update(state, {
        [action.typeOf]: {
          [action.index]: {
            amount: {
              $set: action.amount
            }
          }
        }
    });
    case actionConsts.SET_USAGE_AMOUNT_TOUCHED:
      return update(state, {
        [action.typeOf]: {
          [action.index]: {
            amountTouched: {
              $set: true
            }
          }
        }
    });
    case actionConsts.UPDATE_USAGE_KIND:
      return update(state, {
        [action.typeOf]: {
          [action.index]: {
            id: {
              $set: action.id
            },
            unit: {
              $set: action.unit
            },
            name: {
              $set: action.name
            },
            dataSheet: {
              $set: action.dataSheet,
            },
            technicalDataSheet: {
              $set: action.technicalDataSheet,
            },
            chemDataSheet: {
              $set: action.chemDataSheet,
            }
          }
        }
    });
    case actionConsts.SET_USAGE_KIND_TOUCHED:
      return update(state, {
        [action.typeOf]: {
          [action.index]: {
            kindTouched: {
              $set: true
            }
          }
        }
    });
    case actionConsts.GET_USAGE_SUGGESTIONS_SUCCESS:
      return update(state, {
        suggestions: {
          $set: action.suggestions
        }
    });
    case actionConsts.ADD_EMPTY_USAGE:
      return update(state, {
        [action.typeOf]: {
          $push: [action.usage]
        }
    });
    case actionConsts.ADD_EMPTY_USAGE_SUB:
      if(!state[action.typeOf][action.index].subs) {
        return update(state, {
          [action.typeOf]: {
            [action.index]: {
              subs: {
                $set: [{id: '', name: ''}]
              }
            }
          }
        });
      }
      return update(state, {
        [action.typeOf]: {
          [action.index]: {
            subs: {
              $push: [{id: '', name: ''}]
            }
          }
        }
      });
      case actionConsts.SUB_CHANGE:
        return update(state, {
          [action.typeOf]: {
            [action.index]: {
              subs: {
                [action.index2]: {
                  $set: action.val
                }
              }
            }
          }
        })
        case actionConsts.SUB_REMOVE:
        return update(state, {
          [action.typeOf]: {
            [action.index]: {
              subs: {
                  $splice: [[action.index2, 1]]
              }
            }
          }
        })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Usage/reducer.js